// recentMembersSection/styled.js
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Honey colors
const honeyColors = {
  primary: '#F1C40F',
  primaryLight: '#F4D03F',
  primaryDark: '#D4AC0D',
  amber: '#FFB74D',
  cream: '#FFF8E1',
  honeycomb: '#D4A574',
  surface: '#FFFFFF',
  surfaceHoney: '#FFF9E6',
  border: '#F5E6B3',
  textPrimary: '#3E2723',
  textSecondary: '#5D4037',
  textMuted: '#8D6E63',
  success: '#66BB6A',
  info: '#29B6F6',
  gradientPrimary: 'linear-gradient(135deg, #F1C40F 0%, #FFB74D 100%)',
  gradientSuccess: 'linear-gradient(135deg, #66BB6A 0%, #81C784 100%)',
  shadowLight: '0 2px 8px rgba(212, 165, 116, 0.12)',
  shadowMedium: '0 4px 12px rgba(212, 165, 116, 0.18)',
};

export const SectionContainer = styled(Box)({
  marginBottom: '32px',
  padding: '24px',
  backgroundColor: honeyColors.surface,
  borderRadius: '16px',
  border: `1px solid ${honeyColors.border}`,
  boxShadow: honeyColors.shadowLight,
});

export const SectionHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '24px',
});

export const SectionTitle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
    color: honeyColors.primary,
  },
});

export const SectionTitleText = styled(Typography)({
  fontSize: '1.25rem !important',
  fontWeight: '700 !important',
  color: honeyColors.textPrimary,
  margin: 0,
});

export const ViewAllButton = styled(Button)({
  background: 'transparent',
  color: honeyColors.primary,
  fontWeight: 600,
  fontSize: '0.9rem',
  padding: '6px 16px',
  borderRadius: '8px',
  textTransform: 'none',
  border: `1px solid ${honeyColors.border}`,
  
  '&:hover': {
    background: honeyColors.cream,
    borderColor: honeyColors.primary,
  },
});